import type { AxiosRequestConfig } from 'axios';
import type { RecordOf } from 'immutable';
import { Record } from 'immutable';

import type { Meta } from '../core/actionHelpers';
import {
  createTypedQcsSyncResourcePayloadFactory,
  createTypedQcsSyncResourceStoreFactory,
  type QcsSyncResourceStore,
} from '../core/resourceStoreTypes';

export const INVESTMENT_QUOTES_V2_REDUCER_KEY = 'investmentQuotesV2Store';

export type InvestmentQuoteTypeV2 = {
  id?: string;

  name?: string;
  symbol?: string;
  relatedSymbol?: string;
  lastPrice?: number;
  quoteTime?: string;
  amtChange?: number;
  pctChange?: number;
  volume?: number;
  avgVolume?: number;
  openPrice?: number;
  dayHigh?: number;
  dayLow?: number;
  exchange?: string;
  eps?: number;
  closePrice?: number;
  currentPrice?: number;
  mktCap?: number;
  peRatio?: number;
  divYield?: number;
  yearHigh?: number;
  yearLow?: number;
  fiftyTwoWeekHigh?: number;
  fiftyTwoWeekHighDate?: string;
  fiftyTwoWeekLow?: number;
  fiftyTwoWeekLowDate?: string;
  previousClosePrice?: number;
  realTime?: boolean;
};

export type InvestmentQuoteV2 = RecordOf<InvestmentQuoteTypeV2>;
export const mkInvestmentQuoteV2 = Record<InvestmentQuoteTypeV2>({
  id: undefined,
  name: undefined,
  symbol: undefined,
  relatedSymbol: undefined,
  lastPrice: undefined,
  quoteTime: undefined,
  amtChange: undefined,
  pctChange: undefined,
  volume: undefined,
  avgVolume: undefined,
  openPrice: undefined,
  dayHigh: undefined,
  dayLow: undefined,
  exchange: undefined,
  eps: undefined,
  closePrice: undefined,
  currentPrice: undefined,
  mktCap: undefined,
  peRatio: undefined,
  divYield: undefined,
  yearHigh: undefined,
  yearLow: undefined,
  fiftyTwoWeekHigh: undefined,
  fiftyTwoWeekHighDate: undefined,
  fiftyTwoWeekLow: undefined,
  fiftyTwoWeekLowDate: undefined,
  previousClosePrice: undefined,
  realTime: undefined,
});

export type InvestmentQuotesV2Request = {
  symbols?: string | string[] | null;
};

export type InvestmentQuotesV2Meta = Omit<Meta<InvestmentQuoteTypeV2>, 'axiosConfig'> & {
  axiosConfig?: Omit<AxiosRequestConfig, 'params'> & {
    params?: InvestmentQuotesV2Request & { realTime?: boolean };
  };
};

export type InvestmentQuotesV2Response = {
  resources?: Omit<InvestmentQuoteTypeV2, 'id'>[];
  metaData?: { asOf?: string };
};

export type InvestmentQuotesV2Store = QcsSyncResourceStore<InvestmentQuoteTypeV2>;

export const mkInvestmentQuotesV2Store = createTypedQcsSyncResourceStoreFactory<InvestmentQuoteTypeV2>();
export const mkInvestmentQuotesV2Payload = createTypedQcsSyncResourcePayloadFactory<InvestmentQuoteTypeV2>();

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [INVESTMENT_QUOTES_V2_REDUCER_KEY]: InvestmentQuotesV2Store;
  }
}
